import { ProductsEnum } from '../ExpirationInfoContent'
import ContentLoader from 'react-content-loader'
import * as S from './styles'
import { useSelector } from 'react-redux'
import { IUserOrder } from 'pages/ExpirationInfo/types'
import { RootState } from 'store/modules/rootReducer'

interface IExpirationListProps {
  id?: string
  userOrders: IUserOrder[]
  isLoading: boolean
  getListIcon: (order: IUserOrder) => string
}

const ExpirationList: React.FC<IExpirationListProps> = ({
  id,
  userOrders,
  isLoading,
  getListIcon,
}) => {
  const { isDarkMode } = useSelector((state: RootState) => state.theme)

  const loaderProps = {
    speed: 2,
    backgroundColor: isDarkMode ? '#222222' : '#bababa',
    foregroundColor: isDarkMode ? '#2b2b2b' : '#dedede',
  }

  return (
    <S.ExpirationList id={id}>
      <div className="listHeader">
        <span>Nome</span>
        <span>Produto</span>
        <span>Data de compra</span>
        <span>Data de expiração</span>
      </div>
      <ul>
        {isLoading && (
          <ContentLoader
            width={'100%'}
            height={'300px'}
            style={{ padding: '1rem' }}
            {...loaderProps}
          >
            <rect x="0" y="0" rx="3" ry="3" width="100%" height="60" />
            <rect x="0" y="70" rx="3" ry="3" width="100%" height="60" />
            <rect x="0" y="140" rx="3" ry="3" width="100%" height="60" />
            <rect x="0" y="210" rx="3" ry="3" width="100%" height="60" />
          </ContentLoader>
        )}
        {!isLoading &&
          userOrders !== null &&
          userOrders.map((order) => {
            return (
              <li className="listRow" key={order._id}>
                <div className="listContent">
                  <figure className="listIcon">
                    <img src={getListIcon(order)} alt={`Logo ${order.name}`} />
                  </figure>
                  <span>{order.name}</span>
                </div>
                <span className="listContent">{ProductsEnum[order.type]}</span>
                <span className="listContent">
                  {new Date(order.acceptedAt).toLocaleDateString('en-GB')}
                </span>
                <span className="listContent">
                  {order.name === 'Assinatura Vitalícia' ||
                  order.name === 'Assinatura Vitalícia Premium'
                    ? order.finalDate
                      ? 'Limitado'
                      : 'Ilimitado'
                    : order.finalDate
                    ? new Date(order.finalDate).toLocaleDateString('en-GB')
                    : 'A definir'}
                </span>
              </li>
            )
          })}
        {!isLoading && (!userOrders || userOrders.length === 0) && (
          <li className="noOrdersRow">Você não possui nenhum conteúdo adquirido.</li>
        )}
      </ul>
    </S.ExpirationList>
  )
}

export default ExpirationList
